import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=23778ad2&lang=pug&"
import script from "./SearchBar.vue?vue&type=script&lang=js&"
export * from "./SearchBar.vue?vue&type=script&lang=js&"
import style0 from "./SearchBar.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SearchBar.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23778ad2')) {
      api.createRecord('23778ad2', component.options)
    } else {
      api.reload('23778ad2', component.options)
    }
    module.hot.accept("./SearchBar.vue?vue&type=template&id=23778ad2&lang=pug&", function () {
      api.rerender('23778ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SearchBar.vue"
export default component.exports